import { call, put, takeLatest } from 'redux-saga/effects';
import { getPurchases } from 'api/PurchasesAPI';
import { addNegativeToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import { Purchase } from './types';

/**
 * fetchPurchases
 * Saga for fetching recent purchases
 */
export function* fetchPurchases() {
  try {
    const data: Purchase[] = yield call(getPurchases);
    yield put(actions.fetchPurchasesResponse(data));
  } catch (error) {
    const message = 'Error fetching purchases. Please try again later.';
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([takeLatest(actionTypes.FETCH_PURCHASES_REQUEST, fetchPurchases)]);
